/* eslint-disable @intercom/intercom/no-bare-strings */

import { isPresent } from '@ember/utils';
import { BLOCK_TYPES } from '@intercom/composer-core';

// Re-export BLOCK_TYPES from composer-core for backward compatibility
export { BLOCK_TYPES };
export const TEXT_FORMATTER_MARK_OPTIONS = ['bold', 'italic', 'code', 'anchor', 'span'];
export const ALIGNMENTS = {
  left: 'left',
  center: 'center',
  right: 'right',
  justify: 'justify'
};
export const FONT_FAMILIES_DATA = [{
  text: 'Default',
  value: ''
}, {
  text: 'Serif',
  value: 'serif'
}, {
  text: 'Sans Serif',
  value: 'sans-serif'
}, {
  text: 'Monospace',
  value: 'monospace'
}];
export const FONT_FAMILIES = FONT_FAMILIES_DATA.filter(font => isPresent(font.value)).map(font => font.value);
export const DISALLOWED_COLOR_VALUES = ['transparent'];
export const ALIGN_CLASSES = {
  left: 'intercom-interblocks-align-left',
  center: 'intercom-interblocks-align-center',
  right: 'intercom-interblocks-align-right',
  justify: 'intercom-interblocks-align-justify'
};
export const ALIGN_CLASSES_INVERSE = {
  'intercom-interblocks-align-left': 'left',
  'intercom-interblocks-align-center': 'center',
  'intercom-interblocks-align-right': 'right',
  'intercom-interblocks-align-justify': 'justify'
};
export const BLOCK_CLASSES = {
  blockContainer: 'embercom-prosemirror-composer-block-container',
  audio: 'embercom-prosemirror-composer-audio',
  video: 'embercom-prosemirror-composer-video',
  button: 'embercom-prosemirror-composer-button',
  image: 'embercom-prosemirror-composer-image',
  imageText: 'embercom-prosemirror-composer-imagetext',
  table: 'embercom-prosemirror-composer-table intercom-interblocks-table',
  code: 'embercom-prosemirror-composer-code',
  placeholder: 'embercom-prosemirror-composer-placeholder-block',
  social: 'embercom-prosemirror-composer-social',
  spacer: 'embercom-prosemirror-composer-spacer',
  divider: 'embercom-prosemirror-composer-divider',
  callout: 'embercom-prosemirror-composer-callout',
  collapsibleSection: 'embercom-prosemirror-composer-collapsible-section',
  collapsibleSectionContent: 'embercom-prosemirror-composer-collapsible-section-content'
};
export { DEFAULT_ALIGNMENT, MENTION_CLASS, NO_MARGIN_CLASS } from '@intercom/composer-core';
export const HORIZONTAL_RULE_FALLBACK = '___________________________________________________________';
export const BLOCKS_WITH_STYLE = [BLOCK_TYPES.PARAGRAPH, BLOCK_TYPES.HEADING, BLOCK_TYPES.SUBHEADING, BLOCK_TYPES.SUBHEADING3, BLOCK_TYPES.SUBHEADING4, BLOCK_TYPES.SMALL, BLOCK_TYPES.BUTTON, BLOCK_TYPES.ORDERED_LIST, BLOCK_TYPES.UNORDERED_LIST, BLOCK_TYPES.TABLE, BLOCK_TYPES.TABLE_CELL, BLOCK_TYPES.SOCIAL, BLOCK_TYPES.CALLOUT];
export const TEXT_BLOCKS = [BLOCK_TYPES.PARAGRAPH, BLOCK_TYPES.HEADING, BLOCK_TYPES.SUBHEADING, BLOCK_TYPES.SUBHEADING3, BLOCK_TYPES.SUBHEADING4, BLOCK_TYPES.SMALL, BLOCK_TYPES.ORDERED_LIST, BLOCK_TYPES.UNORDERED_LIST];
export const CALLOUT_BLOCK_BACKGROUND_COLORS = {
  blue: '#e3e7fa80',
  green: '#d7efdc80',
  grey: '#e8e8e880',
  red: '#fed9db80',
  yellow: '#feedaf80',
  default: ''
};
export const CALLOUT_BLOCK_BORDER_COLORS = {
  blue: '#334bfa33',
  green: '#1bb15733',
  grey: '#73737633',
  red: '#fd3a5733',
  yellow: '#fbc91633',
  default: '#73737633'
};